export const REEL_IMAGE = ['https://p0.meituan.net/ingee/43471e1c868ca16ac1bfcb57434370be43807.png', 'https://p0.meituan.net/ingee/7554d11c055fb8223955374a09dc3a3a44827.png', 'https://p0.meituan.net/ingee/9155388db1da38cb4cf32dd34656c41846352.png', 'https://p0.meituan.net/ingee/bebe71261d36ee9fb9e7037c9965bfe947152.png', 'https://p0.meituan.net/ingee/b128031cec041052916f4b1ed4dc752e45496.png'];
export const PACKAGE_PRIZE_VAP = {
    mp4: "https://s3plus.meituan.net/v1/mss_1ada830d56584ddeae1b0899c231c552/goku/lucency/1735191268569-video.mp4",
    configJson: "https://s3plus.meituan.net/v1/mss_1ada830d56584ddeae1b0899c231c552/goku/lucency/1735191268569-config.json"
};
export const POINTER_VAP = {
    mp4: 'https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1770349057101-video.mp4',
    configJson: "https://s3plus.meituan.net/tex-external-advertising/goku_lucency/1770349057101-config.json"
};
export const BID_MAP = {
    MODULE_MV: 'b_daodian_lowcode_7qfwmuew_mv',
    // 模块曝光
    PACKAGE_MODULE_MV: 'b_daodian_lowcode_0ir6qj5v_mv',
    // 券包模块曝光
    PACKAGE_MODULE_BUTTON_MC: 'b_daodian_lowcode_hgu42tg9_mc',
    // 券包模块点击
    BUTTON_MV: 'b_daodian_lowcode_2k2sasct_mv',
    // 按钮曝光
    DRAW_BUTTON_MC: 'b_daodian_lowcode_fcg6r0td_mc',
    // 抽奖按钮点击
    SHARE_BUTTON_MV: 'b_daodian_lowcode_92uw8bw9_mv',
    // 分享按钮曝光
    SHARE_BUTTON_MC: 'b_daodian_lowcode_dtd16b34_mc',
    // 分享按钮点击
    SUBSCRIBE_BUTTON_MV: 'b_daodian_lowcode_cv3jrxio_mv',
    // 预约按钮曝光
    SUBSCRIBE_BUTTON_MC: 'b_daodian_lowcode_e0f50wos_mc',
    // 预约按钮点击
    COMMON_MODAL_MV: 'b_daodian_lowcode_6ljac5di_mv',
    // 普通弹窗曝光
    COMMON_MODAL_MC: 'b_daodian_lowcode_y3wc33px_mc',
    // 普通弹窗点击
    PACKAGE_MODAL_MV: 'b_daodian_lowcode_3z4cf5si_mv',
    // 券包弹窗曝光
    PACKAGE_MODAL_MC: 'b_daodian_lowcode_gkq3nicr_mc',
    // 券包弹窗点击
    RECORD_BUTTON_MC: 'b_daodian_lowcode_0pysp7yt_mc',
    // 领奖记录按钮点击
    RECORD_TO_USE_MC: 'b_daodian_lowcode_qsyon582_mc' // 领奖记录点击去使用
};
export var SHARE_BUTTON_TYPE;
(function (SHARE_BUTTON_TYPE) {
    SHARE_BUTTON_TYPE[SHARE_BUTTON_TYPE["MAIN_SHARE"] = 0] = "MAIN_SHARE";
    SHARE_BUTTON_TYPE[SHARE_BUTTON_TYPE["MODAL_SHARE"] = 1] = "MODAL_SHARE";
})(SHARE_BUTTON_TYPE || (SHARE_BUTTON_TYPE = {}));
export var BUTTON_TYPE;
(function (BUTTON_TYPE) {
    BUTTON_TYPE[BUTTON_TYPE["UNRESERVED_CAN_DRAW"] = 0] = "UNRESERVED_CAN_DRAW";
    BUTTON_TYPE[BUTTON_TYPE["DRAWN_HAS_CHANCES"] = 1] = "DRAWN_HAS_CHANCES";
    BUTTON_TYPE[BUTTON_TYPE["DRAWN_NO_CHANCES"] = 2] = "DRAWN_NO_CHANCES";
})(BUTTON_TYPE || (BUTTON_TYPE = {}));
export var BID_TYPE;
(function (BID_TYPE) {
    BID_TYPE["MV"] = "mv";
    BID_TYPE["MC"] = "mc";
    BID_TYPE["MC_WITH_TAG"] = "mc_with_tag";
})(BID_TYPE || (BID_TYPE = {}));
export const LOCATION_SCENE_TOKEN = 'dd-9cbc1c31cfbf2bba';
export const COMPLETE_TASK_ERROR_CODE_DESC = {
    10009: '任务未开始~',
    10010: '邀请已过期～',
    10019: '助力已达上限~',
    10020: '助力已达上限~',
    10079: '不能给自己助力~'
};
// 事件名称常量
export const TRIGGER_DRAW_EVENT = 'PERIODIC_REWARD_CLAIM_TRIGGER_DRAW';
// 主动塞券成功后的 gif 动效配置
export const JOIN_SUCCESS_GIF_URL = 'https://img.meituan.net/makerjiulv/67375a8b135e64c16b9fb48c24df466b958682.gif';
export const JOIN_SUCCESS_GIF_DURATION = 2700;
export const USER_INFO_VALID_CODE = 401;
export const USER_INFO_EXPIRED = 302;
